import React, { useState, lazy, Suspense } from 'react';
import Modal from 'components/commons/modal';
import Loading from 'components/loading';

const UseTermsText = lazy(() => import('./use-terms-text'));

const UseTermsDialog: React.FC = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <a onClick={() => setOpened(true)}>termos de uso</a>

            <Modal
                visible={opened}
                title="TERMOS DE USO DA PLATAFORMA BIZCAPITAL"
                onClose={() => setOpened(false)}
            >
                <Suspense fallback={<Loading />}>
                    <UseTermsText />
                </Suspense>
            </Modal>
        </>
    );
};

export default UseTermsDialog;
